import pages from './pages';
import routes from './routes';

const en = {
  routes,
  ...pages,
};

export default en;
